// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"737":"793ed6b6","798":"16a1c733","933":"d9c39074"}[chunkId] + ".chunk.css";
};